/**
 * Feature flags. Vite reads VITE_*-prefixed env vars at build time.
 *
 * Phone OTP is wired but inactive until Africa's Talking API keys arrive.
 * Set VITE_PHONE_AUTH_ENABLED=true in kapio-desktop/.env.local (dev) or
 * Cloudflare Pages env vars (prod) to flip the feature on.
 */

export function isPhoneAuthEnabled() {
  return import.meta.env.VITE_PHONE_AUTH_ENABLED === "true";
}
